import { StoreState } from './types';

const initialState: StoreState = {
  dashboard: {
    apps: [],
    fetching: true,
    failed: false
  }
};

export default initialState;
